<template>
    <div class="bg-gray-50 border border-gray-300 py-4 px-6 rounded-lg" :class="{ 'cursor-pointer': document.status !== 'completed' }">
        <div class="flex items-center">
            <div class="flex-auto pr-6">
                <p class="font-medium mb-0.5 leading-snug" v-text="document.label" />
            </div>
            <div @click="open = ! open" class="flex-initial text-2xl">
                <i v-if="document.status !== 'completed' && ! open" class="fas fa-chevron-down" />
                <i v-else-if="document.status !== 'completed' && open" class="fas fa-chevron-up" />
                <i v-else class="fas fa-check-circle text-green-500" />
            </div>
        </div>
        <div v-if="open" class="mt-3">
            <form :id="`upload-${document.type}`" enctype="multipart/form-data" method="POST" ref="form">

                <input class="hidden" type="file" accept="image/*" capture="user"
                    name="document"
                    :id="`${document.id}-take`"
                    @change="submit"
                    ref="take" />
                <input class="hidden" type="file" accept="image/*"
                    name="document"
                    :id="`${document.id}-upload`"
                    @change="submit"
                    ref="upload" />

                <p>We have sent you some documents that need signed via DocuSign, as well as other requirements.</p>

                <div class="flex items-center justify-around mt-3 visible lg:invisible lg:absolute">
                    <div class="flex-auto pr-1">
                        <button @click.prevent="$refs['take'].click()" class="w-full button shadow-action font-semibold bg-action rounded text-white py-3 px-6 my-2">
                            <template v-if="! loading">
                                Take Photo
                            </template>
                            <template v-else>
                                <i class="fa fa-circle-notch fa-spin" />
                            </template>
                        </button>
                    </div>
                    <div class="flex-auto pl-1">
                        <button @click.prevent="$refs['upload'].click()" class="w-full button shadow-action font-semibold bg-action rounded text-white py-3 px-6 my-2">
                            <template v-if="! loading">
                                Upload Photo
                            </template>
                            <template v-else>
                                <i class="fa fa-circle-notch fa-spin" />
                            </template>
                        </button>
                    </div>
                </div>

                <button @click.prevent="$refs['upload'].click()" class="mt-3 invisible absolute lg:visible lg:relative w-full button shadow-action font-semibold bg-action rounded text-white py-3 px-6 my-2">
                    <template v-if="! loading">
                        Upload Photo
                    </template>
                    <template v-else>
                        <i class="fa fa-circle-notch fa-spin" />
                    </template>
                </button>
            </form>
        </div>
    </div>
</template>

<script>

    import { analytics } from './../../../analytics';
    export default {
        props: ['loan', 'document'],

        data() {
            return {
                open: false,
                loading: false
            }
        },

        methods: {
            submit(event) {
                this.loading = true;

                analytics.docusignEvents.uploadDocument({
                    loan_id: this.loan.id,
                    loan_status: this.loan.status,
                    user_id: this.loan.user_id,
                    document_id: this.document.id,
                    document_name: this.document.name,
                    document_label: this.document.label,
                    document_status: this.document.status,
                    document_type: this.document.type,
                    page_name: 'UPLOAD_DOCUMENT',
                });

                let formData = new FormData(), image = event.target.files[0];

                formData.append('document', image);

                this.$http.post(`/account/loans/${this.loan.id}/documents/${this.document.name}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(({ data }) => {
                    if (window.location.href !== data.url) {
                        window.location.href = data.url;
                    } else {
                        window.location.reload();
                    }
                }, error => {
                    console.log(error);
                });
            }
        }
    }
</script>